import React from 'react';
import mailLogo from "../../../assets/images/mail.svg";

const DownloadRequirementsCard  = () => {
  return (
    <div className='ds-card _textAlign_center' data-testid='dl-req-card'>
      <section className='cardSection'>
        <img className='_marginBottom--normal' src={mailLogo} alt="Mail Logo" />
        <h4 className='-darkBlue'>
          {' '}
          Please send your business documents to your account manager via email
          or Viber if you haven't yet.{' '}
        </h4>
        <p className='copy _fontSize--small'>
          {' '}
          Your account manager should have sent you a list of requirements, but
          you can also download it here.{' '}
        </p>
        <a
          href={process.env.REACT_APP_DOCUMENT_CHECKLIST}
          className='ds-btn -primary _fontSize--small-mobileOnly _marginBottom--normal --small'
          style={{ display: 'inline-block' }}
          data-testid='download-list-of-requirements-link'
          target='_blank'
        >
          Download list of requirements
        </a>
        <p className='copy _fontSize--small'>
          {' '}
          After you send your documents, you will receive a status update about
          your application within 2-3 business days{' '}
        </p>
      </section>
    </div>
  );
}

export default DownloadRequirementsCard;



// WEBPACK FOOTER //
// ./src/features/home/components/DownloadRequirementsCard.js